import styled from 'styled-components';
import {
  mobile_width_percentage,
  md_mobile_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const CtaSectionStyles = styled.div`
  margin: 96px auto;
  width: ${mobile_width_percentage}%;

  > div {
    max-width: none;
  }

  .cta-inside {
    padding: 55px 0 40px;
    .cta-text {
      margin: 15px auto 32px;
    }
  }
  @media only screen and (min-width: ${md_mobile_breakpoint}px) {
    .cta-inside {
      padding: 70px 0 50px;
      width: 520px;
      max-width: 80%;
      margin: 0 auto;
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    width: ${mobile_width_percentage}%;
    max-width: 1200px;
  }
`;
